import React from 'react';
import PropType from 'prop-types';
import './WelcomeTooltip.css';
import DragToRotateTooltip from '../DragToRotateTooltip/DragToRotateTooltip';
import { storeTrans } from '../../../../utils/StoreTranslator';
import { lithuaniaMkId, polandMKId } from '../../../../utils/StoreConfigManager';

const browseImg = 'https://cdn.obsess-vr.com/drag-tooltip-desktop.gif';
const productImg = 'https://cdn.obsess-vr.com/mary-kay/hand-icon.png';
const beautyImg = 'https://cdn.obsess-vr.com/mary-kay/product-Hotspot-Icon.png';
const backImg = 'https://cdn.obsess-vr.com/mary-kay/beauty-hotspot.png';
const fontStyleByStoreArr = [polandMKId, lithuaniaMkId];

const WelcomeTooltip = (props) => {
    const { welcomeMessageStyle, children, showBroseTooltip, showProductTooltip, showBeautyTooltip, isVisible,
        storeId, showMobileTooltip, isMobile } = props;
    const tooltipClass = !isVisible ? 'tooltip-fadeout' : '';
    const fontStyleByStore = {
        fontFamily: fontStyleByStoreArr.includes(storeId) ? "MaryKaySansMedium" : null
    };
    return (
        <div id="tooltip-container" className={tooltipClass}>
            <div id="tooltip-component-container" className="flex-center">
                <div className="tooltip-row">
                    <div className="tooltip-col fadeInTooltip">
                        <h3 style={fontStyleByStore}>{storeTrans[storeId]['Navega']}</h3>
                        <span className="tooltip-message" style={fontStyleByStore}>
                            {storeTrans[storeId]['NavegaDes']}
                        </span>
                        <DragToRotateTooltip imgStyle={{ width: '8.5em', height: '8.5em' }} isTemplate image={browseImg} classes={'tooltip-first-img'} />
                    </div>
                    <div className={'tooltip-col ' + (showProductTooltip ? 'fadeInTooltip' : '')}>
                        {showProductTooltip && <><h3 style={fontStyleByStore}>{storeTrans[storeId]['Product']}</h3>
                            <span className="tooltip-message" style={fontStyleByStore}>
                                {storeTrans[storeId]['productDes']}
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '4em', height: '4em' }} isTemplate backImg={backImg} image={productImg} /> </>}
                    </div>
                    <div className={'tooltip-col ' + (showBeautyTooltip ? 'fadeInTooltip' : '')}>
                        {showBeautyTooltip && <><h3 style={fontStyleByStore}>{storeTrans[storeId]['Descub']}</h3>
                            <span className="tooltip-message" style={fontStyleByStore}>
                                {storeTrans[storeId]['DescubDes']}
                            </span>
                            <DragToRotateTooltip imgStyle={{ width: '3em', height: '3em' }} isTemplate image={beautyImg} classes={'star'} /></>}
                    </div>
                    {isMobile && <div style={{ height: "8vh" }} className={'tooltip-col ' + (showMobileTooltip ? 'fadeInTooltip' : '')}>
                        {showMobileTooltip && <>
                            <span className="tooltip-message" style={fontStyleByStore}>
                                {storeTrans[storeId]['portraitViewWarningToolTip']}
                            </span>
                        </>}
                    </div>}
                </div>
                {children}
            </div>
        </div>
    );
};

WelcomeTooltip.propTypes = {
    welcomeMessageStyle: PropType.object,
    showBroseTooltip: PropType.bool,
    showBeautyTooltip: PropType.bool,
    showProductTooltip: PropType.bool,
};

export default WelcomeTooltip;
